import { Component, OnInit, Input, Output, EventEmitter, QueryList, ViewChild, ElementRef, AfterViewInit, SimpleChanges } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CatalogSheetsService } from '../../../services/catalog-sheets/catalog-sheets.service';
import { CatalogSheet } from '../../../services/catalog-sheets/catalog-sheets.model';
import { debounce } from 'lodash';
import { Pagination, mockedData, getPaginationHeader } from 'src/app/utils/getPaginationHeader';
import { removeUnSelectedIds } from 'src/app/utils/RemoveUnSelectedIds';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { MySnackBarService } from '../../../shared/snackbar/my-snackbar.service';
import { GridDataResult, DataStateChangeEvent, PageChangeEvent, ExcelModule, GridComponent, ExcelComponent, FooterComponent, RowArgs, } from '@progress/kendo-angular-grid';
import { SortDescriptor, orderBy, CompositeFilterDescriptor, FilterDescriptor, } from '@progress/kendo-data-query';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { CatalogSheetSingleComponent } from '../catalog-sheet-single/catalog-sheet-single.component';
import { ColumnSettings } from "../../../../app/utils/column-settings.interface";
import { StorageService } from '../../../../app/utils/StorageHelper';
import * as XLSX from 'xlsx';
import { ImportsService } from '../../../services/imports/imports.service'
import { SideNavService } from '../../../services/side-nav/sidenav.service';
import { NotificationHelper } from '../../../utils/NotificationHelper';
import { ExportConfirmationComponent } from 'src/app/shared/export-confirmation/export-confirmation.component';
import { DeleteConfirmationComponent } from '../../../shared/delete-confirmation/delete-confirmation.component';
import { CopyService } from '../../../services/copy/copy.service';

@Component({
  selector: 'app-catalog-sheet-list',
  templateUrl: './catalog-sheet-list.component.html',
  styleUrls: ['./catalog-sheet-list.component.scss'],
})
export class CatalogSheetListComponent implements AfterViewInit, OnInit {
  @ViewChild('grid') myGrid: GridComponent;
  @ViewChild('hiddenfileinput') fileUploader: ElementRef;

  constructor(
    private catalogSheetsService: CatalogSheetsService,
    private router: Router,
    private modalService: NgbModal,
    private snack: MySnackBarService,
    private datePipe: DatePipe,
    private importsService: ImportsService,
    private sideNavService: SideNavService,
    private notificationHelper: NotificationHelper,
    private copyService: CopyService
  ) {
    this.onFilterChange = debounce(this.onFilterChange, 300, { leading: true });
    this.allData = this.allData.bind(this);
  }

  @Input() loading: boolean = true;
  @Input() catalogID: number;
  @Input() catalogSheets: CatalogSheet[] = [];
  @Input() query = {
    PageSize: 25,
    SortTerm: 'name',
    PageNumber: 1,
    SearchTerm: ''
  };
  @Input() pagination: Pagination = mockedData;
  @Output() filterChange = new EventEmitter();
  @Output() onSelectSingle = new EventEmitter();
  @Input()
  mode: 'view' | 'lookup' | 'subgrid' = 'view';
  limits = [25, 50, 75, 100, 250];
  selectedIds: { [key: number]: boolean } = {};
  idForRemove: number | null = null;
  public mySelection: string[] = [];
  public gridView: GridDataResult;
  public pageSize = 25;
  public skip = 0;
  public filter: CompositeFilterDescriptor;
  private data: CatalogSheet[];
  public exportAll: boolean;
  public optDescColumns: boolean;
  public optRowID: boolean;
  public globalRecordCount: number = 1;
  public clickedRowItem;
  @Input() gridClassName: string = "DefaultGrid";
  public filterable: boolean;
  public sort: SortDescriptor[] = [
    {
      field: 'Name',
      dir: 'asc',
    },
  ];
  defaultColumnsConfig: ColumnSettings[] = [
    {
      title: 'Catalog Name',
      field: 'catalog.name',
      width: 200,
      orderIndex: 0,
      hidden: false
    },
    {
      title: 'Name',
      field: 'name',
      width: 200,
      orderIndex: 1,
      hidden: false
    },
    {
      title: 'Description',
      field: 'description',
      width: 250,
      orderIndex: 2,
      hidden: false
    },
    {
      title: 'Price Schedule',
      field: 'priceSchedule.name',
      width: 200,
      orderIndex: 3,
      hidden: true
    },
    {
      title: 'Customer Name',
      field: 'customer.name',
      width: 175,
      orderIndex: 4,
      hidden: true
    },
    {
      title: 'Customer Number',
      field: 'customer.number',
      width: 175,
      orderIndex: 5,
      hidden: true
    },
    {
      title: 'Item Name',
      field: 'item.name',
      width: 175,
      orderIndex: 6,
      hidden: true
    },
    {
      title: 'Item Number',
      field: 'item.number',
      width: 175,
      orderIndex: 7,
      hidden: true
    },
    {
      title: 'Use Base UofM',
      field: 'useBaseUofM',
      width: 100,
      orderIndex: 8,
      hidden: true
    },
    {
      title: 'Location',
      field: 'location.name',
      width: 200,
      orderIndex: 9,
      hidden: true
    },
    {
      title: 'Currency',
      field: 'currency.name',
      width: 200,
      orderIndex: 10,
      hidden: true
    },
    {
      title: 'Effective Date',
      field: 'effectiveDate',
      width: 100,
      orderIndex: 11,
      hidden: true
    },
    {
      title: 'Use Today',
      field: 'useToday',
      width: 100,
      orderIndex: 12,
      hidden: true
    },
  ];
  columnsConfig: ColumnSettings[];

  ngOnInit(): void {
    this.loading = true;
    this.columnsConfig = this.defaultColumnsConfig.map(obj => ({ ...obj }));
    this.loading = false;
  }

  ngOnDestroy(): void {
    this.saveGrid();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.catalogID && !changes.catalogID.firstChange) {
      // We now have an Parent ID so we can change the tooltip.
      document.getElementById('btnAdd').setAttribute('title', 'Add New');
    }
  }

  async onClickCopy() {
    try {
      const ids = [];
      this.mySelection.forEach(async (value) => {
        const response: any = await this.copyService.performCopy(null, "RPMCatalogSheet", Number(value));
        const status: any = response.status;
        if (status === 200) {
          this.snack.openSnackBar(
            'Completed Copy successfully!' + response.body,
            '',
            false,
            'Success',
            'alert-success',
          );
          this.loadListData();
        }
      });
    } catch (e) {
      this.snack.openSnackBar(e.error, '', true, 'Error', 'alert-danger');
    }
  }

  async onClick_Delete() {
    const modalRef = this.modalService.open(DeleteConfirmationComponent);
    modalRef.componentInstance.confirmDelete.subscribe(() => {
      modalRef.close();
      this.DeleteRecords();
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }

  async DeleteRecords() {
    const ids = [];
    this.mySelection.forEach((value) => {
      ids.push(Number(value));
    });

    await this.catalogSheetsService
      .removeByIds(ids)
      .then((showSuccess: VoidFunction) => {
        this.notificationHelper.showStatus('Record(s) deleted successfully!', 'success');
        this.mySelection = [];
      })
      .catch((err: HttpErrorResponse) => {
        this.notificationHelper.showStatus(err.error, "error");
      });

    this.loadListData();
  }

  async onClick_Export(grid: GridComponent, excelComponent: ExcelComponent) {
    this.saveGrid();
    const modalRef = this.modalService.open(ExportConfirmationComponent);
    modalRef.componentInstance.gridRecordCount = this.gridView?.total;
    modalRef.componentInstance.siblingRecordCount = this.globalRecordCount;
    if (this.mode != 'subgrid') {
      modalRef.componentInstance.siblingRecordCount = 0; //no global export if main grid
    }
    modalRef.componentInstance.hasDescColumns = true;
    modalRef.componentInstance.confirmExport.subscribe((options) => {
      modalRef.close();
      this.loading = true;
      this.exportAll = options.optTechnicalStyle;
      this.optDescColumns = options.optDescColumns;
      this.optRowID = options.optRowID;
      if (options.optTechnicalStyle) {
        if (options.optSiblingRecords) {
          excelComponent.fetchData = this.allGlobalSiblingData;
        }
        else {
          excelComponent.fetchData = this.allData;
        }
      }
      grid.saveAsExcel();
      this.query.PageSize = StorageService.PageSize();
      this.loading = false;
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
      this.loading = false;
    });
  }

  public allGlobalSiblingData = (): Promise<any> => {
    this.query.PageSize = 200000;
    this.query.PageNumber = 1;
    this.loading = true;
    return this.catalogSheetsService.getExportList({
      ...this.query
    });
  }

  async getGlobalSiblingDataCount() {
    this.loading = true;
    try {
      const response: any = await this.catalogSheetsService.getList({ PageSize: 1, PageNumber: 1 });
      this.loading = false;
      const pagination = getPaginationHeader(response.headers);
      this.globalRecordCount = pagination.TotalCount;
    } catch (error) {
      this.loading = false;
      console.error("Error fetching total count: ", error);
    }
  }

  async onClick_ExportOLD(grid: GridComponent, excelComponent: ExcelComponent) {
    this.saveGrid();

    const modalRef = this.modalService.open(ExportConfirmationComponent);
    modalRef.componentInstance.gridRecordCount = this.gridView?.total;
    modalRef.componentInstance.confirmReImport.subscribe(() => {
      modalRef.close();
      this.loading = true;
      this.exportAll = true;
      excelComponent.fetchData = this.allData;
      grid.saveAsExcel();
      this.query.PageSize = StorageService.PageSize();
      this.loading = false;
    });
    modalRef.componentInstance.confirmExport.subscribe(() => {
      modalRef.close();
      this.loading = true;
      this.exportAll = false;
      grid.saveAsExcel();
      this.query.PageSize = StorageService.PageSize();
      this.loading = false;
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
      this.loading = false;
    });

  }

  onFilterClick() {
    this.filterable = !this.filterable;
  }

  onResetGridClick() {
    StorageService.removeColumnSettings('CatalogSheetList_Config');
    this.columnsConfig = this.defaultColumnsConfig.map(obj => ({ ...obj }));
    this.ConfigureGrid();
  }

  ConfigureGrid() {
    // Try and pull our grid configuration from the storage.
    let gridConfig: ColumnSettings[] = StorageService.getColumnSettings('CatalogSheetList_Config');

    // If it has not been persisted yet, then persist the default configuration
    if (!gridConfig) {
      StorageService.setColumnSettings('CatalogSheetList_Config', this.defaultColumnsConfig);
    } else {
      // Use the updated configuration for the user.
      this.columnsConfig = gridConfig;
    }

    // restore columns to saved configuration
    this.myGrid.columns.forEach((column) => {
      const columnConfig = this.columnsConfig.find(cc => cc.title === column.title);

      if (columnConfig) {
        column.orderIndex = columnConfig.orderIndex;
        column.hidden = columnConfig.hidden;
        column.width = columnConfig.width;
      }
    });
  }

  saveGrid(): void {
    // save column configuration
    this.myGrid.columns.forEach(column => {
      const columnConfig = this.columnsConfig.find(cc => cc.title === column.title);

      if (columnConfig) {
        columnConfig.hidden = column.hidden;
        columnConfig.orderIndex = column.orderIndex;
        columnConfig.width = column.width;
      }
    });

    // sort the array, this is necessary for the excel export
    this.columnsConfig = this.columnsConfig.sort((cc1, cc2) => {
      if (cc1.orderIndex > cc2.orderIndex) {
        return 1;
      }

      if (cc1.orderIndex < cc2.orderIndex) {
        return -1;
      }

      return 0;
    });

    StorageService.setColumnSettings('CatalogSheetList_Config', this.columnsConfig);
  }

  ngAfterViewInit() {
    this.loading = true;
    this.ConfigureGrid();
    this.loading = false;

    if (this.mode == 'view' || this.mode == 'lookup') {
      this.loadListData();
      this.gridClassName = "DefaultGrid";
    }
    else if (this.mode == 'subgrid') {
      this.loadSubGridData();
      this.gridClassName = "CatalogSheetSubgridClass";
    }

    this.sideNavService.sideNavChangedEvent.subscribe(
      (event) => {
        if (this.mode == "view") {
          let SideNavExpanded_Config: boolean = StorageService.get('SideNavExpanded_Config');
          if (SideNavExpanded_Config == true) {
            this.gridClassName = "DefaultGrid"
          }
          else {
            this.gridClassName = "FullScreenGrid"
          }
        }
      },
    );
  }

  async onFileChange(evt: any) {
    await this.importsService.onFileChange(evt, 'RPMCatalogSheet');
    this.fileUploader.nativeElement.value = null;
    this.loadListData();
  }

  onFileChangeOLD(evt: any) {
    const target: DataTransfer = <DataTransfer>evt.target;

    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      //ws.forEach(function(y) {
      //var worksheet = wb.Sheets[y];
      var headers = {};
      var data = [];
      for (const z in ws) {
        if (z[0] === '!') continue;
        //parse out the column, row, and value
        var col = z.substring(0, 1);
        var row = parseInt(z.substring(1));
        var value = ws[z].v;

        //store header names
        if (row == 1) {
          headers[col] = String(value);
          continue;
        }

        if (!data[row]) data[row] = {};
        data[row][headers[col]] = String(value).trim();
      }
      //drop those first two rows which are empty
      data.shift();
      data.shift();
      console.log(data);
      //});
      var myJSONString = JSON.stringify(data);
      var myEscapedJSONString = myJSONString
        .replace(/[\\]/g, '\\\\')
        .replace(/[\']/g, "\\'")
        .replace(/[\"]/g, '\\"')
        .replace(/[\/]/g, '\\/')
        .replace(/[\b]/g, '\\b')
        .replace(/[\f]/g, '\\f')
        .replace(/[\n]/g, '\\n')
        .replace(/[\r]/g, '\\r')
        .replace(/[\t]/g, '\\t');

      const inputXML: string = "'" + myEscapedJSONString + "'";
      this.performImport(inputXML);
    };

    reader.readAsBinaryString(target.files[0]);

    this.fileUploader.nativeElement.value = null;
  }

  async performImport(inputXML) {
    try {
      const response: any = await this.importsService.performImport(inputXML, 'RPMCatalogSheet');
      const status: any = response.status;
      if (status === 200) {
        this.snack.openSnackBar(
          'Completed Import successfully!' + response.body,
          '',
          false,
          'Success',
          'alert-success',
        );
        this.loadListData();
      }
    } catch (e) {
      this.snack.openSnackBar(e.error, '', true, 'Error', 'alert-danger');
    }
  }

  async loadListData() {
    this.loading = true;
    this.query.PageSize = StorageService.PageSize() ?? 50;
    try {
      if (this.catalogID) {
        document.getElementById('btnAdd').setAttribute('title', 'Add New');
        const response: any = await this.catalogSheetsService.getList({
          Filter_CatalogID: this.catalogID, ...this.query
        });
        this.catalogSheets = response.body;
        this.pagination = getPaginationHeader(response.headers);
        this.gridView = {
          data: this.catalogSheets,
          total: this.pagination.TotalCount,
        };
      }
      else {
        const response: any = await this.catalogSheetsService.getList(this.query);
        this.catalogSheets = response.body;
        this.pagination = getPaginationHeader(response.headers);
        this.gridView = {
          data: this.catalogSheets,
          total: this.pagination.TotalCount,
        };

      }
    } catch (e) {
    } finally {
      this.loading = false;
    }
    this.getGlobalSiblingDataCount();
  }

  async loadSubGridData() {
    const params = { PageSize: StorageService.PageSize() ?? 50 };
    this.catalogSheets = [];
    this.gridView = {
      data: this.catalogSheets,
      total: 0,
    };
    this.loading = true;
    try {
      if (this.catalogID) {
        document.getElementById('btnAdd').setAttribute('title', 'Add New');
        const response: any = await this.catalogSheetsService.getList({
          Filter_CatalogID: this.catalogID, ...params
        });
        this.catalogSheets = response.body;
        this.pagination = getPaginationHeader(response.headers);
        this.gridView = {
          data: this.catalogSheets,
          total: this.pagination.TotalCount,
        };
      }
    } catch (e) {
    } finally {
      this.loading = false;
    }
    this.getGlobalSiblingDataCount();
  }

  onFilterChange() {
    this.filterChange.emit(this.query);
    this.loadListData();
  }

  onRefresh() {
    this.loadListData();
  }

  onCellClick(e) {
    this.clickedRowItem = e.dataItem;
  }

  onDblClick() {
    if (this.clickedRowItem) {
      if (this.mode === 'lookup') {
        this.onSelectSingle.emit(this.clickedRowItem);
      }
      else {
        this.router.navigate(['/price/catalog-sheet/' + this.clickedRowItem.id]);
      }
    }
  }

  public gridFilterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    this.query = { PageNumber: 1, PageSize: this.query.PageSize, SortTerm: 'name', SearchTerm: '' };
    if (filter.filters.length > 0) {
      filter.filters.forEach((value) => {
        const myFilter: FilterDescriptor = value as FilterDescriptor;

        //mhr this code ChatGPT made more universal
        const fieldName = (myFilter.field as string).replace(/\./g, '').toLowerCase(); //remove periods
        let filterValue = myFilter.value || "";
        if (fieldName.includes('date')) {
          filterValue = this.datePipe.transform(myFilter.value, "MM/dd/yyyy");
        }
        if (fieldName.includes('use')) { //need to specify booleans to be false rather than blank
          filterValue = myFilter.value || false;
        }
        const filterField = `Filter_${fieldName}`;
        const operandField = `Operand_${fieldName}`;
        //console.log(filterField);
        //console.log(filterValue);
        //console.log(operandField);
        //console.log(myFilter.operator);
        const params = { ...this.query, [filterField]: filterValue, [operandField]: myFilter.operator };
        this.query = params;


        //const notNullValue = (myFilter.value == null) ? "" : myFilter.value;
        //if (myFilter.field == 'description') {
        //  const Filter_Description = notNullValue;
        //  const Operand_Description = myFilter.operator;
        //  const params = { ...this.query, Filter_Description, Operand_Description };
        //  this.query = params;
        //}
        //if (myFilter.field == 'name') {
        //  const Filter_Name = notNullValue;
        //  const Operand_Name = myFilter.operator;
        //  const params = { ...this.query, Filter_Name, Operand_Name };
        //  this.query = params;
        //}
        //if (myFilter.field == 'useToday') {
        //  const Filter_UseToday = notNullValue;
        //  const Operand_UseToday = myFilter.operator;
        //  const params = { ...this.query, Filter_UseToday, Operand_UseToday };
        //  this.query = params;
        //}
        //if (myFilter.field == 'effectiveDate') {
        //  const Filter_EffectiveDate = this.datePipe.transform(notNullValue, "MM/dd/yyyy");
        //  const Operand_EffectiveDate = myFilter.operator;
        //  const params = { ...this.query, Filter_EffectiveDate, Operand_EffectiveDate };
        //  this.query = params;
        //}
        //if (myFilter.field == 'defaultCurrency.name') {
        //  const Filter_Currency = notNullValue;
        //  const Operand_Currency = myFilter.operator;
        //  const params = { ...this.query, Filter_Currency, Operand_Currency };
        //  this.query = params;
        //}
      });
    }
    this.onFilterChange();
  }
  edit(id: number) {
    this.router.navigate([`/price/catalog-sheet/${id}`]);
  }

  onCreate() {
    if (this.catalogID) {
      this.router.navigate(['/price/catalog-sheet/new', { catalogID: this.catalogID }],);
    }
    else {
      this.router.navigate(['/price/catalog-sheet/new']);
    }
  }

  async showRemovePopUp(content) {
    const result = await this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
    }).result;
  }

  public allData = (): Promise<any> => {
    this.query.PageSize = 200000;
    this.query.PageNumber = 1;
    this.loading = true;
    return this.catalogSheetsService.getExportList(this.query);
  }

  async remove(modal) {
    const ids = [];
    this.mySelection.forEach((value) => {
      ids.push(Number(value));
    });
    await this.catalogSheetsService
      .removeByIds(ids)
      .then((showSuccess: VoidFunction) => {
        this.snack.openSnackBar(
          'Record(s) deleted successfully!',
          '',
          false,
          'Success',
          'alert-success',
        );
        this.mySelection = [];
      })
      .catch((err: HttpErrorResponse) => {
        this.snack.openSnackBar(
          err.error,
          '',
          true,
          'Error',
          'alert-danger',
        );
      });

    modal.close();
    this.loadListData();
  }

  get disableDeleteBtn() {
    return !Object.keys(this.mySelection).length;
  }

  get disableEditBtn() {
    return Object.keys(this.mySelection).length !== 1;
  }

  onSelectSingleItem(item) {
    this.onSelectSingle.emit(item);
  }
  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.query.PageNumber = event.skip / event.take + 1;
    this.loadListData();
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    let fieldName = sort[0].field.toLowerCase();
    if (sort[0].dir == 'asc') {
      this.query.SortTerm = fieldName;
    } else if (sort[0].dir == 'desc') {
      this.query.SortTerm = '-' + fieldName;
    } else {
      this.query.SortTerm = fieldName;
    }
    this.loadListData();
  }
}
